import { MyPositionsContent } from './MyPositionsContent';
import { getChainInfo } from 'constants/chainInfo';
import {
  DEFAULT_MAINNET_CHAIN_ID,
  DEFAULT_TESTNET_CHAIN_ID
} from 'constants/chains';

import { isMyPositionSupportedChain, isTestnetChain } from 'utils/chains';

import { useWeb3React } from 'hooks/useWeb3React';

import Button from 'components/ui/Button';

import { useToggleAccountDrawer } from 'components/AccountDrawer';

export const MyPositions = () => {
  const toggleWalletDrawer = useToggleAccountDrawer();

  const { account, chainId } = useWeb3React();

  const showConnectAWallet = Boolean(!account);
  const isSupportedChain = isMyPositionSupportedChain(chainId);
  const isTestnet = isTestnetChain(chainId);

  const unsupportedNetworkText = `Connect to ${isTestnet ? getChainInfo(DEFAULT_TESTNET_CHAIN_ID)?.label : getChainInfo(DEFAULT_MAINNET_CHAIN_ID)?.label}`;

  return (
    <div className='relative flex flex-col bg-blue-900'>
      {showConnectAWallet && (
        <>
          <div className='flex min-h-10 items-center justify-center p-5 text-white'>
            Connect a wallet to view your positions.
          </div>

          <Button
            variant='primary'
            className='absolute -bottom-14 left-1/2 z-11 -ml-px w-41.25 -translate-x-1/2'
            onClick={toggleWalletDrawer}
          >
            Connect
          </Button>
        </>
      )}

      {!showConnectAWallet && !isSupportedChain && (
        <div className='flex min-h-10 items-center justify-center p-5 text-white'>
          {unsupportedNetworkText}
        </div>
      )}

      {!showConnectAWallet && isSupportedChain && chainId && (
        <MyPositionsContent chainId={chainId} />
      )}
    </div>
  );
};
